import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext(null);

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bis_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Terjadi kesalahan. Silakan coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

import { setDynamicAccess } from "@/lib/roles";

const loadAccess = () => api.get("/role-access").then((r) => setDynamicAccess(r.data)).catch(() => {});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("bis_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then(async (res) => { await loadAccess(); setUser(res.data); })
      .catch(() => localStorage.removeItem("bis_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    localStorage.setItem("bis_token", data.token);
    await loadAccess();
    setUser(data.user);
    return data.user;
  };

  const registerAlumni = async (name, username, password) => {
    const { data } = await api.post("/auth/register-alumni", { name, username, password });
    localStorage.setItem("bis_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("bis_token");
    setUser(null);
  };

  const applySession = (token, u) => {
    if (token) localStorage.setItem("bis_token", token);
    if (u) setUser(u);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, registerAlumni, logout, applySession }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
